import request from "@/utils/request";
// 新增
export function saveOpKnowledgeBaseArticle(data) {
  return request({
    url: "/opKnowledgeBaseArticle/save",
    method: "post",
    data,
  });
}

// 获取区域分页树
export function getOpKnowledgeBaseCategoryTreeApi() {
  return request({
    url: "/opKnowledgeBaseCategory/knowledgeCategories",
    method: "get",
    data: {},
  });
}

// 分页查询
export function getArticlePageListApi(data) {
  return request({
    url: "/opKnowledgeBaseArticle/page",
    method: "post",
    data,
  });
}

// 查询详情
export function getArticleInfoByIdApi(id) {
  return request({
    url: `/opKnowledgeBaseArticle${id}`,
    method: "get",
  });
}

// 修改
export function updateArticleInfoApi(data) {
  return request({
    url: "/opKnowledgeBaseArticle/update",
    method: "post",
    data,
  });
}

// 删除
export function deleteArticleByIdApi(id) {
  return request({
    url: `/opKnowledgeBaseArticle/delete/${id}`,
    method: "delete",
  });
}

//修改文章状态
export function updateArticleStatusApi(id, status) {
  return request({
    url: `/opKnowledgeBaseArticle/updateStatus/${id}/${status}`,
    method: "put",
  });
}
